module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }],
    staticClass: "grey lighten-4",
    class: _vm.appClasses,
    style: (_vm.appStyle),
    attrs: {
      "id": "app"
    }
  }, [(_vm.globalSelectedAppointments && _vm.globalSelectedAppointments.length > 0) ? _c('bulk-actions', {
    attrs: {
      "selected-appointments": _vm.globalSelectedAppointments
    },
    on: {
      "deselect": function($event) {
        _vm.globalSelectedAppointments = []
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "11"
    },
    attrs: {
      "touchless": "",
      "disable-resize-watcher": true,
      "dark": "",
      "width": "450",
      "app": "",
      "right": ""
    },
    model: {
      value: (_vm.showHelp),
      callback: function($$v) {
        _vm.showHelp = $$v
      },
      expression: "showHelp"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "visible-ios-only main",
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('contextual-help', {
    attrs: {
      "touch": _vm.tutToucher
    },
    on: {
      "close": function($event) {
        _vm.showHelp = false
      }
    }
  })], 1), _vm._v(" "), _c('v-navigation-drawer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }],
    staticStyle: {
      "z-index": "11"
    },
    attrs: {
      "app": "",
      "enable-resize-watcher": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "visible-ios-only main",
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('account-switcher', {
    staticClass: "mt-2",
    attrs: {
      "groups": _vm.groups
    },
    on: {
      "became": _vm.doLogin
    },
    model: {
      value: (_vm.me),
      callback: function($$v) {
        _vm.me = $$v
      },
      expression: "me"
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0 mt-3",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.navItems), function(item) {
    return [(!item.meta.hidden_from_nav && !item.meta.showChildren) ? _c('v-list-tile', {
      key: ("menu-" + (item.name)),
      class: item.meta.klass,
      on: {
        "click": function($event) {
          return _vm.goto(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(item.meta.icon))]), _vm._v(" " + _vm._s(item.name) + "\n              ")], 1)], 1), _vm._v(" "), (item.meta.new) ? _c('v-list-tile-avatar', [_c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "dark": "",
        "color": "primary"
      }
    }, [_vm._v("New")])], 1) : _vm._e(), _vm._v(" "), (item.meta.updated) ? _c('v-list-tile-avatar', [_c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "dark": "",
        "color": "warning"
      }
    }, [_vm._v("Updated")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.children && item.meta.showChildren) ? _c('v-list-group', {
      key: ("group-" + (item.name))
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(item.meta.icon))]), _vm._v(" " + _vm._s(item.name))], 1)], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return (!child.meta.hidden_from_nav === true) ? _c('v-list-tile', {
        key: ("child-" + i),
        staticClass: "nav child ml-3",
        class: ("hidden-ios-" + (child.meta.hidden_from_ios)),
        nativeOn: {
          "click": function($event) {
            return _vm.goto(child)
          }
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
        staticClass: "mr-2"
      }, [_vm._v(_vm._s(child.meta.icon))]), _vm._v(" " + _vm._s(child.name))], 1)], 1), _vm._v(" "), (child.meta.new) ? _c('v-list-tile-avatar', [_c('v-chip', {
        staticClass: "v-chip--x-small",
        attrs: {
          "dark": "",
          "color": "primary"
        }
      }, [_vm._v("New")])], 1) : _vm._e(), _vm._v(" "), (child.meta.updated) ? _c('v-list-tile-avatar', [_c('v-chip', {
        staticClass: "v-chip--x-small",
        attrs: {
          "dark": "",
          "color": "warning"
        }
      }, [_vm._v("Updated")])], 1) : _vm._e()], 1) : _vm._e()
    })], 2) : _vm._e()]
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        More apps\n      ")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.SETTINGS,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("settings")]), _vm._v(" Advanced settings\n          ")], 1)], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.DASHBOARD,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("dashboard")]), _vm._v("\n            Dashboard\n          ")], 1)], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4"
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("exit_to_app")]), _vm._v(" Logout\n          ")], 1)], 1)], 1)], 2), _vm._v(" "), _c('v-card-text', [_c('v-btn', {
    attrs: {
      "href": _vm.LINKS.INVITE,
      "target": "_blank",
      "small": "",
      "block": "",
      "outline": ""
    }
  }, [_vm._v("\n        Invite teammates\n      ")]), _vm._v(" "), (!_vm.isInstalled) ? _c('v-img', {
    staticClass: "mt-3 hidden-sm-and-up",
    attrs: {
      "src": "/static/img/pwa.png"
    },
    on: {
      "click": _vm.installMobile
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('version', {
    staticClass: "pa-3 white--text"
  }), _vm._v(" "), _c('random-splash', {
    staticClass: "p-4 mt-2",
    attrs: {
      "with-accreditation": true,
      "with-description": false
    },
    on: {
      "unpashbackground": _vm.setBackground
    }
  })], 1), _vm._v(" "), (_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    staticClass: "header-toolbar",
    class: _vm.themeColor,
    attrs: {
      "status": "",
      "fixed": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }],
    staticClass: "header-toolbar main",
    class: _vm.themeColor,
    attrs: {
      "dark": "",
      "fixed": "",
      "app": "",
      "flat": ""
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    on: {
      "click": function($event) {
        return _vm.$router.push("/")
      }
    }
  }, [_c('span', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("Appointment")]), _c('span', {
    staticStyle: {
      "color": "black !important"
    }
  }, [_vm._v("Guru")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "hidden-xs-only",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ml-3",
          attrs: {
            "to": "/calendar",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("event")])], 1)]
      }
    }], null, false, 3781911913)
  }, [_vm._v(" "), _c('span', [_vm._v("Calendar")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "to": "/appointments",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("alarm_on")])], 1)]
      }
    }], null, false, 2719616345)
  }, [_vm._v(" "), _c('span', [_vm._v("Appointments")])]), _vm._v(" "), _c('v-tooltip', {
    staticClass: "hidden-xs-only",
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "id": "global-link-clients",
            "to": "/clients",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("people")])], 1)]
      }
    }], null, false, 2808696110)
  }, [_vm._v(" "), _c('span', [_vm._v("Clients")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "id": "global-link-invoices",
            "to": "/invoices",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("post_add")])], 1)]
      }
    }], null, false, 4038287915)
  }, [_vm._v(" "), _c('span', [_vm._v("Invoices")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-xs-only",
          attrs: {
            "id": "global-link-reports",
            "to": "/reports",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("trending_up")])], 1)]
      }
    }], null, false, 2718203230)
  }, [_vm._v(" "), _c('span', [_vm._v("Reports")])])] : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.appIsReady && _vm.showUpgrade) ? [_c('v-btn', {
    attrs: {
      "icon": "",
      "to": "/get-started",
      "color": "info",
      "id": "global-guides-btn"
    }
  }, [_c('v-icon', [_vm._v("tour")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.billingUrl,
      "color": "green",
      "icon": _vm.$vuetify.breakpoint.xs
    }
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("Upgrade")]) : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v("upgrade")])], 1)] : _vm._e(), _vm._v(" "), (true) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showHelp = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_vm._v("help")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.meta.with_datepicker === true),
      expression: "$route.meta.with_datepicker === true"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showRangePicker = true
      }
    }
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2 hidden-xs-only",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.showProfileDialog),
      callback: function($$v) {
        _vm.showProfileDialog = $$v
      },
      expression: "showProfileDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n          Update your profile picture\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showProfileDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('uploader', {
    attrs: {
      "title": "Upload a profile picture",
      "subtitle": "A profile picture or square logo will be used in the AppointmentGuru app for your clients and in your own account. It will be shown as a round picture or avatar.",
      "filename": "profile_picture"
    },
    on: {
      "uploadsuccess": function($event) {
        _vm.getMe();
        _vm.showProfileDialog = false
      }
    },
    scopedSlots: _vm._u([{
      key: "gallery",
      fn: function(props) {
        return [_c('v-subheader', [_vm._v("Examples of how this may look in various places")]), _vm._v(" "), _vm._l((props.images), function(img, index) {
          return _c('v-layout', {
            key: index
          }, [_c('v-flex', [_c('v-subheader', [_vm._v("Avatar view")]), _vm._v(" "), _c('v-avatar', [_c('img', {
            attrs: {
              "src": img
            }
          })])], 1), _vm._v(" "), _c('v-flex', [_c('v-subheader', [_vm._v("Normal view")]), _vm._v(" "), _c('img', {
            attrs: {
              "src": img
            }
          })], 1)], 1)
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "open-on-hover": "",
      "bottom": "",
      "offset-y": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticClass: "black--text",
          attrs: {
            "slot": "activator",
            "color": "white"
          },
          slot: "activator"
        }, on), [(_vm.globalInitRequestLoading) ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "amber",
            "width": "2"
          }
        }) : [(_vm.getProfilePicture(_vm.me)) ? _c('img', {
          attrs: {
            "src": _vm.getProfilePicture(_vm.me)
          }
        }) : _c('span', [_vm._v(_vm._s(_vm.initials(_vm.me)))])]], 2)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 grey lighten-4"
  }, [_vm._v("Hi " + _vm._s(_vm.me.first_name) + "\n          "), _vm._v(" "), (_vm.appIsReady && _vm.showUpgrade) ? _c('v-btn', {
    staticClass: "pa-0",
    staticStyle: {
      "font-size": "10px",
      "height": "18px"
    },
    attrs: {
      "small": "",
      "dark": "",
      "label": "",
      "href": _vm.billingUrl,
      "color": "success"
    }
  }, [_vm._v("upgrade")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.showProfileDialog = true
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Update profile picture")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("face")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.SETTINGS_SPACES,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Account")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("settings")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.LINKS.SETTINGS_PROFILE,
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("My profile")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("account_box")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.init
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Reload settings")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Logout")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("logout")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showiframe),
      callback: function($$v) {
        _vm.showiframe = $$v
      },
      expression: "showiframe"
    }
  }, [(_vm.showiframe) ? _c('ag-iframe', {
    attrs: {
      "src": _vm.iframeSrc
    },
    on: {
      "update:src": function($event) {
        _vm.iframeSrc = $event
      },
      "close": function($event) {
        _vm.showiframe = false
      }
    }
  }) : _vm._e()], 1)], 2), _vm._v(" "), _c('main', [_c('v-content', [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "flat",
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "zeropadd",
    attrs: {
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "flat",
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), (!_vm.globalDataLoading && _vm.isLoggedIn && _vm.isReadOnly === true) ? _c('read-only-block', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lookups.invitations && _vm.lookups.invitations.length > 0) ? _c('space-invite-handler') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoggedIn) ? _c('router-view', {
    on: {
      "install": function($event) {
        _vm.showInstallInstructions = true
      }
    }
  }) : _c('login-page')], 1), _vm._v(" "), (_vm.isLoggedIn) ? _c('session', {
    on: {
      "loggedin": _vm.initSession
    }
  }) : _vm._e(), _vm._v(" "), _c('GlobalEvents', {
    attrs: {
      "filter": _vm.globalEventFilter
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 191) { return null; }
        return _vm.launchClientSearch.apply(null, arguments)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "w", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        _vm.showiframe = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "a", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.openGlobalDialog(true, 'QuickCreate')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "i", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.launchInvoiceDialog({
          appointments: _vm.$store.getters.activeAppointments
        })
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "t", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.launchPaymentDialog()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "n", undefined, $event.key, undefined)) { return null; }
        if (!$event.ctrlKey) { return null; }
        if ($event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        _vm.launchNewClientDialog({
          touch: Math.random()
        })
      }]
    }
  }), _vm._v(" "), _c('v-fab-transition', [_c('v-speed-dial', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }],
    class: {
      'mb-5': _vm.$vuetify.breakpoint.xsOnly
    },
    attrs: {
      "id": "main-speed-dail",
      "bottom": "",
      "right": "",
      "fixed": "",
      "direction": "top"
    },
    model: {
      value: (_vm.expandFab),
      callback: function($$v) {
        _vm.expandFab = $$v
      },
      expression: "expandFab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "blue darken-2",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.expandFab),
      callback: function($$v) {
        _vm.expandFab = $$v
      },
      expression: "expandFab"
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20,
      "open-delay": 1000
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'QuickCreate')
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("alarm_on")])], 1), _vm._v(" "), _c('span', [_vm._v("New Appointment (ctrl + a)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "indigo"
    },
    on: {
      "click": function($event) {
        return _vm.launchInvoiceDialog({
          appointments: _vm.$store.getters.activeAppointments
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("content_copy")])], 1), _vm._v(" "), _c('span', [_vm._v("New Invoice (ctrl + i)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "orange"
    },
    on: {
      "click": function($event) {
        return _vm.launchPaymentDialog()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("attach_money")])], 1), _vm._v(" "), _c('span', [_vm._v("New Payment (ctrl + t)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.launchNewClientDialog({
          touch: Math.random()
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("New Client (ctrl + n)")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "value": _vm.expandFab,
      "left": "",
      "nudge-left": 20
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "small": "",
      "color": "yellow"
    },
    on: {
      "click": _vm.launchClientSearch
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('span', [_vm._v("Search (/)")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('real-time-beacon'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.spaces.globalDialog.fullscreen,
      "max-width": "600",
      "lazy": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showGlobalDialogSpace),
      callback: function($$v) {
        _vm.showGlobalDialogSpace = $$v
      },
      expression: "showGlobalDialogSpace"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.spaces.globalDialog.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "globalDialog")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$store.dispatch("HIDE_SPACE", "globalDialog")
      }
    }
  }, [(_vm.spaces.globalDialog.visible) ? _c(_vm.spaces.globalDialog.component, _vm._g(_vm._b({
    tag: "component",
    on: {
      "success": _vm.pushGlobalEvent,
      "close": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "globalDialog")
      }
    }
  }, 'component', _vm.spaces.globalDialog.options, false, true), _vm.spaces.globalDialog.actions)) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "persistent": "",
      "fullscreen": _vm.spaces.secondaryGlobalDialog.fullscreen,
      "max-width": "600"
    },
    model: {
      value: (_vm.showGlobalDialogSecondarySpace),
      callback: function($$v) {
        _vm.showGlobalDialogSecondarySpace = $$v
      },
      expression: "showGlobalDialogSecondarySpace"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.spaces.secondaryGlobalDialog.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")
      }
    }
  }, [(_vm.showGlobalDialogSecondarySpace) ? _c(_vm.spaces.secondaryGlobalDialog.component, _vm._g(_vm._b({
    tag: "component",
    on: {
      "close": function($event) {
        return _vm.$store.dispatch("HIDE_SPACE", "secondaryGlobalDialog")
      }
    }
  }, 'component', _vm.spaces.secondaryGlobalDialog.options, false, true), _vm.spaces.secondaryGlobalDialog.actions)) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.showRangePicker),
      callback: function($$v) {
        _vm.showRangePicker = $$v
      },
      expression: "showRangePicker"
    }
  }, [(_vm.appPlatform === 'ios' && _vm.$vuetify.breakpoint.xsOnly) ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "dense": "",
      "dark": "",
      "flat": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v("Choose a date range")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showRangePicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('date-range-picker', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.showRangePicker = false
      },
      "close": function($event) {
        _vm.showRangePicker = false
      }
    },
    model: {
      value: (_vm.activeDateRange),
      callback: function($$v) {
        _vm.activeDateRange = $$v
      },
      expression: "activeDateRange"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: (_vm.activeDialog),
      callback: function($$v) {
        _vm.activeDialog = $$v
      },
      expression: "activeDialog"
    }
  }, [(_vm.appPlatform === 'ios') ? _c('v-system-bar', {
    class: _vm.themeColor,
    attrs: {
      "status": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "flat": "",
      "color": _vm.themeColor
    }
  }, [(_vm.dialogTitle) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.dialogTitle))]) : _c('v-toolbar-title', [_vm._v(_vm._s(_vm.appointment.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeActiveDialog
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeActiveDialog.apply(null, arguments)
      }
    }
  }, [(_vm.activeComponent && _vm.activeComponent.length > 1) ? _c('global-dialog-container', {
    attrs: {
      "with-toolbar": false,
      "initial": _vm.activeComponent,
      "appointment": _vm.appointment
    },
    on: {
      "close": _vm.closeActiveDialog
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isLoggedIn) ? _c('v-bottom-nav', {
    staticClass: "elevation-20",
    staticStyle: {
      "border-top": "1px solid #ccc"
    },
    attrs: {
      "app": "",
      "value": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/",
      "value": "home"
    }
  }, [_c('span', [_vm._v("Home")]), _vm._v(" "), _c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/calendar",
      "value": "calendar"
    }
  }, [_c('span', [_vm._v("Calendar")]), _vm._v(" "), _c('v-icon', [_vm._v("today")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/invoices",
      "value": "invoices"
    }
  }, [_c('span', [_vm._v("Invoices")]), _vm._v(" "), _c('v-icon', [_vm._v("content_copy")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/clients",
      "value": "clients"
    }
  }, [_c('span', [_vm._v("Clients")]), _vm._v(" "), _c('v-icon', [_vm._v("group")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-footer', {
    staticClass: "pa-3 mt-5 hidden-xs-only",
    attrs: {
      "app": "",
      "fluid": ""
    }
  }, [_c('span', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n        Crafted in South Africa especially for you.")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('version', {
    attrs: {
      "withReload": false
    }
  })], 1), _vm._v(" "), _c('v-bottom-sheet', {
    model: {
      value: (_vm.showInstallInstructions),
      callback: function($$v) {
        _vm.showInstallInstructions = $$v
      },
      expression: "showInstallInstructions"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline justify-center grey lighten-4 py-0"
  }, [_vm._v("\n          Install on this device\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showInstallInstructions = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('center', [_c('v-img', {
    staticClass: "mb-3",
    attrs: {
      "src": "/static/img/icons/apple-touch-icon-60x60.png",
      "alt": "AppointmentGuru",
      "width": "60",
      "height": "60"
    }
  })], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0 pb-0 mb-0"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('ul', {
    staticClass: "mb-3"
  }, [_c('li', [_vm._v("Click on the share icon "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("ios_share")])], 1), _vm._v(" "), _c('li', [_vm._v("Scroll and click on \"add to home screen\"")])]), _vm._v(" "), _c('p', [_vm._v("\n          The app icon will be added to your home screen and you can interact\n          with AppointmentGuru just like you would any app that you have installed\n          from the iStore or Play store\n          ")])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-icon', [_vm._v("south")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.mobileAppNotice),
      callback: function($$v) {
        _vm.mobileAppNotice = $$v
      },
      expression: "mobileAppNotice"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n          A better option for mobile\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          We are moving our app out of the app stores.\n          We are moving to a mobile web app.\n          It will allow us to ship updates to our mobile app more regularly\n          and provide you with a better experience on mobile.\n\n          To install our mobile app: click the button below.\n\n          "), _c('a', {
    attrs: {
      "href": "https://app.appointmentguru.co/",
      "target": "_blank"
    }
  }, [_c('v-img', {
    staticClass: "my-3 mx-3",
    attrs: {
      "src": "/static/img/pwa.png"
    }
  })], 1), _vm._v("\n\n          This will launch the app in your browser.\n          Click on the share icon and then \"add to home screen\"\n        ")]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mobileAppNotice = false
      }
    }
  }, [_vm._v("I'll keep with this app for now")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1406
// module chunks = 9